import { render, staticRenderFns } from "./WheelRecord.vue?vue&type=template&id=1d5fb505&scoped=true&"
import script from "./WheelRecord.vue?vue&type=script&lang=js&"
export * from "./WheelRecord.vue?vue&type=script&lang=js&"
import style0 from "./WheelRecord.vue?vue&type=style&index=0&id=1d5fb505&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5fb505",
  null
  
)

export default component.exports